export interface RunnableCallback<T> {
  once(...args: any[]): T
  run(...args: any[]): T
}

export class Callback<T, A extends unknown[]> implements RunnableCallback<T> {
  private isCalled = false
  private cache: T | null = null

  constructor(private readonly callback: (...args: A) => T) {}

  run(...args: A): T {
    this.cache = this.callback(...args)
    this.isCalled = true
    return this.cache
  }

  once(...args: A): T {
    if (!this.isCalled) {
      return this.run(...args)
    }

    return this.cache as T
  }
}
